module.exports = __webpack_public_path__ + "img/9_50.9f2a1c5b.png";